<template>
  <button type="button" value="Print" :class="['btn-warning', btncls]">
    <i class="fa-solid fa-print"></i>
    {{ btnvalue }}
  </button>
</template>

<script>
export default {
  props: {
    btnvalue: {
      type: String,
      default: "Print", // Keep default redirect behavior for all existing usages
    },
    btncls: {
      type: String,
      default: "xsbtn", // Keep default redirect behavior for all existing usages
    },
  },
};
</script>
